import styled from 'styled-components';
import { Box } from '@interstate/components/Box';
import { Typography } from '@interstate/components/Typography';

export const UnavailableContainer = styled(Box)`
    && {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        background-color: ${({ theme }) => theme.tokens.ColorSurfaceSubdued};
        min-height: 66.5px;
    }
`;

export const UnavailableText = styled(Typography)`
    && {
        color: ${({ theme }) => theme.tokens.SemColorOnSurfaceMuted};
        text-align: center;
    }
`;
